import './Summary.css';
import { useEffect, useState } from 'react';
import { AssignmentService } from '../../Services/AssignmentService';
import { getUserInfoFromSession } from '../../Services/session.mgmt';
import PropTypes from 'prop-types';

function VCRsummary({ teamWrkBpiNb }) {
  const [vcrData, setVcrData] = useState({});
  const [vehloc, setvehloc] = useState({});
  const [assignmentDetails, setAssignmentDetails] = useState([{}]);
  const userInfo = getUserInfoFromSession();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchVcr = async () => {
      try {
        const [VCRResponse, VehLocResponse, GroundingResponse, AssignmentDetailsResponse] = await Promise.all([
          AssignmentService.getVcrDetails(teamWrkBpiNb),
          AssignmentService.getVehLocDetails(teamWrkBpiNb),
          AssignmentService.getGroundingInfo(teamWrkBpiNb),
          AssignmentService.getAssignmentInfo(teamWrkBpiNb, userInfo.cntrctrNb),
        ]);
        setVcrData(VCRResponse.data.vcr);
        setvehloc({
          vehlocTypCd: GroundingResponse?.data?.vehLocTypCd ?? '',
          auctCd: GroundingResponse?.data?.auctLocCd ?? '',
          auctDs: GroundingResponse?.data?.auctLocNm ?? '',
          teamWrkBpiNb: teamWrkBpiNb,
          addrLine1Tx: VehLocResponse?.data?.addrLine1Tx ?? '',
          addrLine2Tx: VehLocResponse?.data?.addrLine2Tx ?? '',
          cityNm: VehLocResponse?.data?.cityNm ?? '',
          custNm: GroundingResponse?.data?.custNm ?? '',
          stAbbrCd: VehLocResponse?.data?.stAbbrCd ?? '',
          zipCd: VehLocResponse?.data?.zipCd ?? '',
          phnCityAreaCd: VehLocResponse?.data?.phnCityAreaCd ?? '',
          phnNb: VehLocResponse?.data?.phnNb ?? '',
          lstUpdtUserId: GroundingResponse?.data?.lstUpdtUserId ?? '',
          vehLocNm: VehLocResponse?.data?.vehLocNm ?? '',
        });
        setAssignmentDetails(AssignmentDetailsResponse.data);
      } catch (e) {
        console.log('Error Fetching VCR Details: ' + e);
      } finally {
        setLoading(false);
      }
    };
    fetchVcr();
  }, [teamWrkBpiNb, userInfo.cntrctrNb]);

  const displayGenCndtnDs = (cdValue)=>{
    if (!cdValue) return '';

    let displayVal;
    if(cdValue === 1) displayVal = 'CLEAN';
    else if(cdValue === 2) displayVal = 'JUNK';
    else if(cdValue === 3) displayVal = 'ROUGH';
    else displayVal = 'AVERAGE';

    return displayVal;
  }

  const displayMechCndtnDs = (cdValue)=>{
    if (!cdValue) return '';

    let displayVal = '';
    if(cdValue === 1) displayVal = 'GOOD';
    else if(cdValue === 2) displayVal = 'Poor';
    else if(cdValue === 3) displayVal = 'Average';

    return displayVal;
  }

  const displayGlsCndtnDs = (cdValue)=>{
    if (!cdValue) return '';

    let displayVal = '';
    if(cdValue === 1) displayVal = 'GOOD';
    else if(cdValue === 2) displayVal = 'SCRATCHED';
    else if(cdValue === 3) displayVal = 'BROKEN';

    return displayVal;
  }

  const displayTireCndtnDs = (cdValue)=>{
    if (!cdValue) return '';

    let displayVal = '';
    if(cdValue === 1) displayVal = 'BALD';
    else if(cdValue === 2) displayVal = 'GOOD';
    else if(cdValue === 3) displayVal = 'NONE';
    else if(cdValue === 4) displayVal = 'AVERAGE';

    return displayVal;
  }

  const displayIntCndtnDs = (cdValue)=>{
    if (!cdValue) return '';

    let displayVal = '';
    if(cdValue === 1) displayVal = 'CLEAN';
    else if(cdValue === 2) displayVal = 'ROUGH';
    else if(cdValue === 3) displayVal = 'AVERAGE';

    return displayVal;
  }

  const displayCndtnDs = (cdValue)=>{
    if (!cdValue) return '';

    let displayVal;
    if(cdValue === 1) displayVal = 'DENTED';
    else if(cdValue === 2) displayVal = 'GOOD';
    else if(cdValue === 3) displayVal = 'POOR';
    else if(cdValue === 4) displayVal = 'RUSTED';
    else if(cdValue === 5) displayVal = 'AVERAGE';
    else displayVal = 'AVERAGE';

    return displayVal;
  }

  function displayZipPostal(countryCd){
    if(countryCd === "CAN") return 'Postal code';
    return 'ZIP';
  }

  function displayStateProvince(countryCd){
    if(countryCd === "CAN") return 'PROVINCE';
    return 'STATE';
  }


  return loading ? (
    <div>Loading</div>
  ) : (
    <div className="details_cntr_summmary">
      <div id="invoiceheader" className="center">
        VCR
      </div>
      <div id="persnprptbl_cntr">
        <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md
        fmc-px-3 fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md
          fmc-px-3 fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-6">CUSTOMER NAME: {vehloc.custNm} </div>
                <div className="fds-layout-grid__cell--span-6">ACCOUNT NO: {assignmentDetails[0]?.custAcctNb} </div>
              </div>
            </div>
          </section>

          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md
          fmc-px-3 fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-3">
                  Date of Recovery:
                  <br />
                  {vcrData?.rcvrDt}
                  <br />
                </div>
                <div className="fds-layout-grid__cell--span-1">
                  YEAR: {assignmentDetails[0]?.vehMdlYr}
                  <br />
                </div>
                <div className="fds-layout-grid__cell--span-1">MAKE: {assignmentDetails[0]?.makeDescTx}</div>
                <div className="fds-layout-grid__cell--span-2">
                  MODEL: {assignmentDetails[0]?.mdlDescTx}
                  <br />
                </div>
                <div className="fds-layout-grid__cell--span-4">
                  VEHICLE IDENTIFICATION NUMBER: {assignmentDetails[0]?.vinSerialNb}{' '}
                </div>
              </div>
            </div>
          </section>
          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md
          fmc-px-3 fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-6">
                  PREPARED BY(NAME OF THE EMPLOYEE): {vcrData?.prepByTx}
                </div>
                <div className="fds-layout-grid__cell--span-6">DATE PREPARED: {vcrData?.prepDt} </div>
              </div>
            </div>
          </section>
          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md
          fmc-px-3 fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-2">MILAGE : {vcrData?.vehMlgeNb}</div>
                <div className="fds-layout-grid__cell--span-4">IGNITION KEY NO: {assignmentDetails[0]?.keyIgntnNb}</div>
                <div className="fds-layout-grid__cell--span-2"> COLOR: {assignmentDetails[0]?.vehColorTx}</div>
                <div className="fds-layout-grid__cell--span-4">
                  General Condition:&nbsp;{displayGenCndtnDs(vcrData?.genCndtnCd)}
                </div>
              </div>
            </div>
          </section>

          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md
          fmc-px-3 fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div>
              <div className="fds-layout-grid p-0">
                <div className="fds-layout-grid__cell--span-12">
                  {/* Flex container to align the key and radio buttons horizontally */}
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: '20px' }}>KEYS:</div>
                    <fieldset className="fmc-check fmc-check--horizontal" style={{ display: 'flex', gap: '20px' }}>
                      <label>
                        <input type="radio" name="keysInd" value="Y" checked={vcrData?.keysInd === 'Y'}
                               readOnly onChange={() => {}} />
                        <span>YES</span>
                      </label>
                      <label>
                        <input type="radio" name="keysInd" value="N" checked={vcrData?.keysInd === 'N'} readOnly
                               onChange={() => {}} />
                        <span>NO</span>
                      </label>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md fmc-px-3
          fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-2"> ACCESSORIES:</div>
                <div className="fds-layout-grid__cell--span-2">
                  <div className="fmc-check">
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-1"
                        value="Auto Trans"
                        checked={vcrData?.accAtrnsIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">Auto Trans</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        className="disable-input"
                        name="checkbox-item-2"
                        value="A/C"
                        checked={vcrData?.accAcIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">A/C</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="Vinyl Roof"
                        checked={vcrData?.accVnlRfIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">Vinyl Roof</span>
                    </label>
                  </div>
                </div>
                <div className="fds-layout-grid__cell--span-2">
                  <div className="fmc-check">
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="P Seats"
                        checked={vcrData?.accPwrSeatIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">P .Seats</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-1"
                        value="P windows"
                        checked={vcrData?.accPwrWinIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">P .Windows</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="FM Radio"
                        checked={vcrData?.accFmRadIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">Radio</span>
                    </label>
                  </div>
                </div>
                <div className="fds-layout-grid__cell--span-4">
                  <div className="fmc-check">
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="item-2"
                        checked={vcrData?.accAftcRdoIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">CD</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="item-2"
                        checked={vcrData?.accTiltIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">Tilt Wheel</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="item-2"
                        checked={vcrData?.accCrsCtlIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">Cruise control</span>
                    </label>
                  </div>
                </div>
                <div className="fds-layout-grid__cell--span-2">
                  <div className="fmc-check">
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-1"
                        value="item-1"
                        checked={vcrData?.accDieselIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">Diesel</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md fmc-px-3
          fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-2">
                  MECHANICAL
                  <br />
                  {displayMechCndtnDs(vcrData?.mechCndtnCd)}
                </div>
                <div className="fds-layout-grid__cell--span-3">
                  GLASS:
                  <br />
                  <div>
                    {displayGlsCndtnDs(vcrData?.glsCndtnCd)}
                  </div>
                  <br />
                  INDICATOR LOCATION:
                  <br />
                  {vcrData?.glsBrknDs}
                </div>
                <div className="fds-layout-grid__cell--span-4">
                  {' '}
                  TIRES : <br />
                  Left Front:
                  {displayTireCndtnDs(vcrData?.lfTireCndtnCd)}
                  <br />
                  Left Rear:
                  {displayTireCndtnDs(vcrData?.lrTireCndtnCd)}
                  <br />
                  Right Front:
                  {displayTireCndtnDs(vcrData?.rfTireCndtnCd)}
                  <br />
                  Right Rear:
                  {displayTireCndtnDs(vcrData?.rrTireCndtnCd)}
                  <br />
                  Spare:
                  {displayTireCndtnDs(vcrData?.spTireCndtnCd)}
                  <br />
                </div>
                <div className="fds-layout-grid__cell--span-3">
                  INTERIOR:
                  <br />
                  {displayIntCndtnDs(vcrData?.intCndtnCd)}
                  <br />
                  Explain:
                  {vcrData?.intExplDs}
                </div>
              </div>
            </div>
          </section>

          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md fmc-px-3
          fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-3">
                  {' '}
                  BODY: <br />
                  Body:{' '}{displayCndtnDs(vcrData?.ovrlBodyCndtnCd)}
                  <br />
                  Paint:{' '}{displayCndtnDs(vcrData?.ovrlPntCndtnCd)}
                  <br />
                  Bumper:{' '}{displayCndtnDs(vcrData?.ovrlBmprCndtnCd)}
                  <br />
                </div>
                <div className="fds-layout-grid__cell--span-3">
                  <div> Dent/Rust Location:</div>
                  <div> Driver Side:</div>
                  <div className="fmc-check">
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="P. Seats"
                        checked={vcrData?.cndtnDsfQpIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1"> Front Quarter Panel</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-1"
                        value="item-1"
                        checked={vcrData?.cndtnDsfDrIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span>Front Door</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="item-2"
                        checked={vcrData?.cndtnDsrDrIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span>Rear Door </span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="P Seats"
                        checked={vcrData?.cndtnDsrQpIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span> Rear Quarter Panel</span>
                    </label>
                  </div>
                </div>

                <div className="fds-layout-grid__cell--span-3">
                  <div> Passenger Side:</div>
                  <div className="fmc-check">
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="P Seats"
                        checked={vcrData?.cndtnPsfQpIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">Front Quarter Panel</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-1"
                        value="item-1"
                        checked={vcrData?.cndtnPsfDrIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span>Front Door</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="item-2"
                        checked={vcrData?.cndtnPsrDrIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span>Rear Door </span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="P Seats"
                        checked={vcrData?.cndtnPsrQpIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span>Rear Quarter Panel</span>
                    </label>
                  </div>
                </div>
                <div className="fds-layout-grid__cell--span-1">
                  <div> Top</div>
                  <div className="fmc-check">
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="item-2"
                        checked={vcrData?.cndtnHoodIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span>Hood</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="item-2"
                        checked={vcrData?.cndtnRoofIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span>Roof </span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-2"
                        value="item-2"
                        checked={vcrData?.cndtnTrnkIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span>Trunk</span>
                    </label>
                  </div>
                </div>
                <div className="fds-layout-grid__cell--span-2">
                  <div>Bumper</div>
                  <div className="fmc-check">
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-1"
                        value="item-1"
                        checked={vcrData?.cndtnBumpfIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">Front</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-item-1"
                        value="item-1"
                        checked={vcrData?.cndtnBumprIn === 'Y'}
                        readOnly 
                        onChange={() => {}}
                      />
                      <span className="r-1">Rear</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md fmc-px-3
          fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-12">REMARKS MISSING EQUIPMENT: {vcrData?.msgEquipDs} </div>
              </div>
            </div>
          </section>
          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md fmc-px-3
          fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-12">
                  ESTIMATED INSURANCE DAMAGE AMOUNT: {vcrData?.dmgEstAm}{' '}
                </div>
              </div>
            </div>
          </section>
          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md
          fmc-px-3 fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-6">
                  VEHICLE RECOVERED FROM <br />
                  <div>
                    <fieldset className="fmc-check fmc-check--horizontal">
                      <label>
                        <input
                          type="radio"
                          name="vehRcvrdFromNm"
                          value="item-1"
                          checked={vcrData?.vehRcvrdFromNm === 'CUSTOMER'}
                          readOnly 
                          onChange={() => {}}
                        />
                        <span>Customer</span>
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="vehRcvrdFromNm"
                          value="item-3"
                          checked={vcrData?.vehRcvrdFromNm !== 'CUSTOMER'}
                          readOnly 
                          onChange={() => {}}
                        />
                        <span>Other(SPECIFY)</span>
                      </label>
                      <label>
                        <input
                          type="text"
                          name="text-1"
                          value={vcrData?.vehRcvrdFromNm === 'CUSTOMER' ? '' : vcrData?.vehRcvrdFromNm}
                          disabled={vcrData?.vehRcvrdFromNm === 'CUSTOMER'}
                        />
                        <span style={{display: "none"}}>SonarQube fix</span>
                      </label>
                    </fieldset>
                  </div>
                </div>
                <div className="fds-layout-grid__cell--span-6 fds-flex__col-offset-3">
                  RECOVERED FROM :<br />
                  ADDRESS: {vcrData?.vehRcvrdAddrTx} <br />
                  CITY: {vcrData?.vehRcvrdCityNm} <br />
                  {displayStateProvince(userInfo.countryCd)}: {vcrData?.vehRcvrdStAbbrCd} <br />
                  {displayZipPostal(userInfo.countryCd)}: {vcrData?.vehRcvrdZipCd} <br />
                </div>
              </div>
            </div>
          </section>
          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md
          fmc-px-3 fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-6">WAS RELEASE AND SIGNED BY CUSTOMER:</div>
                <div className="fds-layout-grid__cell--span-6">
                  <div>
                    <fieldset className="fmc-check fmc-check--horizontal">
                      <label>
                        <input type="radio" name="cstRlsIn" value="item-1" checked={vcrData?.cstRlsIn === 'Y'}
                               readOnly onChange={() => {}} />
                        <span>YES</span>
                      </label>

                      <label>
                        <input type="radio" name="cstRlsIn" value="item-3" checked={vcrData?.cstRlsIn === 'N'}
                               readOnly onChange={() => {}} />
                        <span>NO</span>
                      </label>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md fmc-px-3 fmc-pb-3-sm
          fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-6">
                  IF NO, WERE PROPER AUTHORITIES NOTIFIED? <br />
                  <div>
                    <fieldset className="fmc-check fmc-check--horizontal">
                      <label>
                        <input type="radio" name="athNtfyIn" value="NO" checked={vcrData?.athNtfyIn === 'N'}
                               readOnly onChange={() => {}} />
                        <span>NO IF NO EXPLAIN BELOW</span>
                      </label>

                      <label>
                        <input type="radio" name="athNtfyIn" value="item-3" checked={vcrData?.athNtfyIn === 'Y'}
                               readOnly onChange={() => {}} />
                        <span>YES</span>
                      </label>
                    </fieldset>
                  </div>
                </div>
                <div className="fds-layout-grid__cell--span-6">
                  AUTHORITIES NOTIFIED :<br />
                  NAME: {vcrData?.athNtfyNm ? vcrData?.athNtfyNm : ''} <br />
                  ADDRESS: {vcrData?.athNtfyAddrTx ? vcrData?.athNtfyAddrTx : ''} <br />
                  CITY: {vcrData?.athNtfyCityNm ? vcrData?.athNtfyCityNm : ''} <br />
                  {displayStateProvince(userInfo.countryCd)}:{' '}
                  {vcrData?.athNtfyStAbbrCd ? vcrData?.athNtfyStAbbrCd : ''} <br />
                  {displayZipPostal(userInfo.countryCd)}:{' '}
                  {vcrData?.athNtfyZipCd ? vcrData?.athNtfyZipCd : ''} <br />
                </div>
              </div>
            </div>
          </section>

          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md fmc-px-3
          fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-12">OTHER COMMENTS :</div>
                <div className="fds-layout-grid__cell--span-12"> {vcrData?.othCmtDs}</div>
              </div>
            </div>
          </section>
          <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md fmc-px-3
          fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
            <div className="fds-layout-gri p-0">
              <div className="fds-layout-grid__inner p-0 ">
                <div className="fds-layout-grid__cell--span-6">
                  VEHICLE LOCATED AT: <br />
                  <div>
                    <fieldset className="fmc-check fmc-check--vertical">
                      <label>
                        <input type="radio" name="vehlocTypCd" value="item-1" checked={vehloc.vehlocTypCd === 'A'}
                               readOnly onChange={() => {}} />
                        <span>AUCTION</span>
                        <span>{vehloc.auctDs}</span>
                      </label>
                      <label>
                        <input type="radio" name="vehlocTypCd" value="item-3" checked={vehloc.vehlocTypCd === 'C'}
                               readOnly onChange={() => {}} />
                        <span>CONTRACTOR</span>
                      </label>
                      <label>
                        <input type="radio" name="vehlocTypCd" value="item-1" checked={vehloc.vehlocTypCd === 'D'}
                               readOnly onChange={() => {}} />
                        <span>DEALER</span>
                      </label>

                      <label>
                        <input type="radio" name="vehlocTypCd" value="item-3" checked={vehloc.vehlocTypCd === 'O'}
                               readOnly onChange={() => {}} />
                        <span>OTHER</span>
                      </label>
                    </fieldset>
                  </div>
                  <br />
                </div>
                <div className="fds-layout-grid__cell--span-6">
                  <br />
                  <br />
                  NAME: {vehloc.vehLocNm} <br />
                  ADDRESS: {vehloc.addrLine1Tx} {vehloc.addrLine2Tx} <br />
                  CITY: {vehloc.cityNm} <br />
                  STATE/PROV: {vehloc.stAbbrCd} {vehloc.zipCd} <br />
PHONE: {vehloc.phnCityAreaCd} {vehloc.phnNb} <br />
                </div>
              </div>
            </div>
          </section>
        </section>
        <div className="para">
          <ul className="fmc-list">
            <li>
              {' '}
              Prior to recording the mileage reflected on the vehicle’s odometer consider the age , appearance and
              condition of the vehicle and look for indicator of mileage discrepancies such as oil change stickers
              ,repair work receipt, warranty book entries and odometer replacement stickers .Note any mileage
              discrepancies or inconsistencies in the Comments section.
            </li>
            <li>
              {' '}
              California Repossession :In accordance with Section 75005.115 of the Business and Professions Code , this
              condition report is a general assessment of the collateral and does not include all damage or missing
              parts.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

VCRsummary.propTypes = {
  teamWrkBpiNb: PropTypes.any,
};

export default VCRsummary;
